import { FirefoxAdapter, GoogleAdapter, LastPassAdapter, /* PhotoAdapter, */ SpreadsheetAdapter } from '@heybesafe/shared';
import ImportWizard from '../components/ImportWizard';

// Browser-built-in managers sit together (Google, Firefox) with the generic
// spreadsheet fallback last. Firefox is its own tile even though it shares
// Google's CSV shape — see shared/src/importers/firefox.tsx.
// TODO(photo-import): PhotoAdapter is on ice — re-enable when the OCR flow ships.
const ADAPTERS = [LastPassAdapter, GoogleAdapter, FirefoxAdapter, SpreadsheetAdapter];

export default function ImportPage() {
  return <ImportWizard adapters={ADAPTERS} />;
}
